type RecursiveOmit<T, Keys> = T extends object
  ? { [K in Exclude<keyof T, Keys>]: RecursiveOmit<T[K], Keys> }
  : T

export const recursiveOmit = <T, OmittedKey extends string>(
  input: T,
  omitted: OmittedKey,
): RecursiveOmit<T, OmittedKey> => {
  return (
    typeof input === 'object' && !Array.isArray(input) && input != null
      ? Object.fromEntries(
          Object.entries(input)
            .filter(([key, _value]) => key !== omitted)
            .map(([key, value]) => [
              key,
              typeof value === 'object' ? recursiveOmit(value, omitted) : value,
            ]),
        )
      : input
  ) as RecursiveOmit<T, OmittedKey>
}
